export const environment = {
  production: false,
  environment_name: 'dev',
  client_id:'0bab40e3-5208-41ee-b810-24f2c1d7bfaf',
  tenant_autority:'https://login.microsoftonline.com/'+'548d26ab-8caa-49e1-97c2-a1b1a06cc39c' ,
  redirect_url: 'https://planopro-dev.ko.com/auth-response',
  api_base_url: 'https://aswa-tccc-pib-dev-pyth-backend.azurewebsites.net/',
  domain_name: '',
  app_url: 'https://planopro-dev.ko.com',
  picturesAccount: 'storageinswa01us2dev',
  picturesContainer: 'planopro-dev',
};